<template>
  <w-icon-wrapper
    icon-name='work-text-block-added-icon'
    width="24.63"
    height="25.39"
    viewBox="0 0 24.63 25.39"
  >
    <path
      id="Vereinigungsmenge_6"
      data-name="Vereinigungsmenge 6"
      d="M2.87,25.39A2.877,2.877,0,0,1,0,22.52V4.26A2.876,2.876,0,0,1,2.87,1.39H14.84a6.161,6.161,0,0,0-.931,1.8H2.87A1.071,1.071,0,0,0,1.8,4.26V22.53A1.071,1.071,0,0,0,2.87,23.6H17.68a1.071,1.071,0,0,0,1.07-1.07V10.93a6.463,6.463,0,0,0,.88.07,5.673,5.673,0,0,0,.92-.08v11.6a2.877,2.877,0,0,1-2.87,2.87Zm.83-3.451a.7.7,0,1,1,0-1.4H16.68a.7.7,0,1,1,0,1.4Zm0-3.16a.7.7,0,1,1,0-1.4H16.68a.7.7,0,1,1,0,1.4Zm2.01-3.17a.7.7,0,0,1,0-1.4h.22V9.4H4.4v.42a.7.7,0,0,1-1.4,0V8h7.26V9.82a.7.7,0,0,1-1.4,0V9.4H7.33v4.81h.22a.7.7,0,0,1,0,1.4Zm6.74-.34a.7.7,0,1,1,0-1.4h4.23a.7.7,0,1,1,0,1.4Zm0-2.87a.7.7,0,1,1,0-1.4h4.23a.7.7,0,1,1,0,1.4ZM14.63,5a5,5,0,1,1,5,5A5,5,0,0,1,14.63,5Zm2.31-.371-.46.461a.321.321,0,0,0,0,.46l2.1,2.1a.327.327,0,0,0,.45,0h.021l3.71-3.71a.321.321,0,0,0,0-.46l-.46-.46a.319.319,0,0,0-.46,0L18.81,6.04,17.4,4.63a.321.321,0,0,0-.46,0Zm-4.49,4.89a.7.7,0,1,1,0-1.4h2.07a5.89,5.89,0,0,0,1.18,1.4Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkTextBlockAddedIcon' };
</script>